import _ from 'lodash';
import { isEmptyVal } from '@/utils';
import {
  convertSoftBundleInfo2State,
  convertPureReferralCouponInfo2State,
} from '@/views/config/coupon/helper/result-to-state';
import { computePromotionDiscountInfoMap } from '@/views/config/coupon/helper/compute';
import Vue from 'vue';
import { PROMOTION_TYPE, couponFetchStatus } from '@/views/config/coupon/helper/constant';

export const PROMOTION_ACTION_TYPES = {
  initPromotionState: 'init/promotion/state',
};

const state = {
  promotionInfo: {},
};

const getters = {
  promotionInfo: (state) => state.promotionInfo,
  allPromotionInfoStatusList: (state, getters) => {
    return _.chain(getters.promotionInfo)
      .values()
      .map(p => p.status)
      .value();
  },
  promotionDiscountInfoMap: (state, getters) => computePromotionDiscountInfoMap(getters.promotionInfo),
  promotionTotalDiscount: (state, getters) => {
    return _.chain(getters.promotionDiscountInfoMap)
      .values()
      .sumBy('totalDiscount')
      .value();
  },
  planTotalDiscount: (state, getters) => {
    return getters.promotionTotalDiscount + getters.discountWithAmountMap.totalDiscount;
  },
  /**
   * @description soft bundle plan configuration
   * @return {SoftBundleConfigBean}
   */
  softBundleConfiguration: (_, getters) => getters.partnerRefer?.features?.softBundleConfig,
  isExistSoftBundleConfig: (_, getters) => !isEmptyVal(getters.softBundleConfiguration),
  partnerUseInSoftBundle: (_, getters)=>  {
    return getters.partnerRefer?.features?.useInSoftBundle;
  },
  softBundleUseByPriceEngine: (state, getters) => {
    return _.get(getters.softBundleConfiguration, ['config', 'usePriceEngine'], false);
  },
  softBundleValidateByCoupon: (_, getters) => {
    return !isEmptyVal(getters.softBundleConfiguration) && getters.partnerRefer?.rules?.validateByCoupon;
  },
  softBundleState: (state, getters) => {
    const basicInfo = getters.promotionInfo?.[PROMOTION_TYPE.softBundle] || {};
    const discountInfo = getters.promotionDiscountInfoMap?.[PROMOTION_TYPE.softBundle] || {};
    const status = basicInfo?.status;
    const lastStatus = basicInfo?.lastStatus;
    const bundlePlanMap = basicInfo?.getBundlePlanMap?.();

    return {
      status: status,
      lastStatus: lastStatus,
      basicInfo: basicInfo,
      discountInfo: discountInfo,
      isSuccess: status === couponFetchStatus.successfully,
      isPending: status === couponFetchStatus.pending,
      isFailure: status === couponFetchStatus.failure,
      isIdle: status === couponFetchStatus.idle,
      code: getters.partnerRefer?.jointsaleCode,
      bundleName: getters.softBundleConfiguration?.config?.bundleName,
      bundlePlanMap,
    };
  },
};

const mutations = {
  addPromotionInfo(state, info) {
    Vue.set(state.promotionInfo, info.promotionType, info);
  },
  removePromotionInfo(state, promotionType) {
    Vue.delete(state.promotionInfo, promotionType);
  },
  updatePromotionInfoStatus(state, info) {
    const { promotionType, status, lastStatus } = info;

    if (!promotionType || !status || !state.promotionInfo[promotionType]) return;

    Vue.set(state.promotionInfo, promotionType, {
      ...state.promotionInfo[promotionType] || {},
      status,
      lastStatus,
    });
  },
};

const actions = {
  [PROMOTION_ACTION_TYPES.initPromotionState](context) {
    const { commit, getters } = context;
    const { bundlePlanPriceList, features, rules, referralCouponCode } = getters.partnerRefer;

    // soft bundle with price engine to drive price change
    if (features?.useInSoftBundle && !isEmptyVal(bundlePlanPriceList)) {
      const promotionInfo = convertSoftBundleInfo2State({ bundlePlanPriceList }, context);
      commit('addPromotionInfo', promotionInfo);
    } else if (rules?.validateByReferralCoupon && !isEmptyVal(referralCouponCode)) {
      const promotionInfo = convertPureReferralCouponInfo2State(context);
      commit('addPromotionInfo', promotionInfo);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
